import cn from 'classnames'
import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from '@/intl'
import formInputStyles from '@/scopes/checkout/components/PersonalDetailsForm/Inputs/FormInput.module.css'
import {
  availablePostalCodeCountriesSelector,
} from '@/scopes/checkout/components/PersonalDetailsForm/selectors'
import { useTrackFieldValidation } from '@/scopes/checkout/components/PersonalDetailsForm/useTrackFieldValidation'
import { useParticipantsFormStepStore } from '@/scopes/checkout/infrastructure/store/useParticipantsFormStepStore'
import { TextInput } from '@/scopes/common/components/FormElements/TextInput'
import { getPostalCodeExample } from '@/scopes/common/components/FormElements/utils/postalCodePatternUtils'
import styles from '../Form.module.css'

export function PostalCodeInput({
  name,
  pattern,
  required,
  watchCountryFieldName,
}: {
  name: string
  pattern?: string
  required?: boolean
  watchCountryFieldName?: string
}) {
  const intl = useIntl()
  const availablePostalCodeCountries = useParticipantsFormStepStore(availablePostalCodeCountriesSelector)
  useTrackFieldValidation(name)
  const [patternToUse, setPatternToUse] = React.useState<string | undefined>(pattern)
  const [postalCodeExample, setPostalCodeExample] = React.useState('')

  const {
    watch,
    trigger,
  } = useFormContext()

  const watchCountryFieldValue = watchCountryFieldName ? watch(watchCountryFieldName) : null
  const currentPostalCodeValue = watch(name)

  React.useEffect(() => {
    if (!watchCountryFieldValue) {
      setPatternToUse(pattern)
      setPostalCodeExample('')
      return
    }

    const matchingPostalCodeCountry = availablePostalCodeCountries.find(({ isoCode }: { isoCode: string }) => isoCode?.toLowerCase() === watchCountryFieldValue?.toLowerCase())

    if (!matchingPostalCodeCountry) {
      setPatternToUse(pattern)
      setPostalCodeExample('')
      return
    }

    setPatternToUse(matchingPostalCodeCountry.pattern)
    setPostalCodeExample(getPostalCodeExample(matchingPostalCodeCountry.isoCode))
    if (currentPostalCodeValue) {
      trigger(name)
    }
  }, [trigger, name, watchCountryFieldValue, availablePostalCodeCountries, currentPostalCodeValue, pattern])

  return (
    <TextInput
      name={name}
      label={intl.formatMessage({ id: 'checkout_steps_participants_form_field_label_postal_code' })}
      required={required}
      requiredErrorMessage={intl.formatMessage({ id: 'checkout_steps_participants_form_field_required_error_message_postal_code' })}
      pattern={patternToUse}
      patternErrorMessage={
        intl.formatMessage(
          { id: 'checkout_steps_participants_form_field_pattern_error_message_postal_code' },
          { postalCodeExample },
        )
      }
      formFieldClass={cn(styles.personalDetailsFormField, formInputStyles.formFieldXS)}
    />

  )
}
